import React, { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function ChartBar(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="M21 18.938h-.938V3.75a.563.563 0 0 0-.563-.563h-5.25a.563.563 0 0 0-.563.563v3.938H9a.563.563 0 0 0-.563.563v3.938H4.5a.563.563 0 0 0-.563.563v6.188H3a.563.563 0 1 0 0 1.125h18a.563.563 0 1 0 0-1.125M14.812 4.315h4.125V18.94h-4.125zm-5.25 4.5h4.125V18.94H9.562zm-4.5 4.5h3.375v5.625H5.062z" fill="currentColor"/>
    </BaseIcon>
  );
}
